export const validateEng = (value: string) => {
  const engRegex = /[a-zA-Z]/;
  return engRegex.test(value);
};
export const validateKor = (value: string) => {
  const korRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
  return korRegex.test(value);
};
export const validateNum = (value: string) => {
  const numRegex = /^[0-9]*$/;
  return numRegex.test(value);
};
export const validateSpc = (value: string) => {
  const spcRegex = /[~!@#$%^&*()_.,+'/₩;|`<>?=\\":{}-]/;
  const emptyCheckRegex = /\s/g;
  return emptyCheckRegex.test(value) || spcRegex.test(value);
};

export const validateEmail = (email: string) => {
  const emaiilRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emaiilRegex.test(email);
};

export const validateEmailInput = (input: string) => {
  const inputRegex = /^[a-zA-Z0-9@.]*$/;
  return inputRegex.test(input);
};

export const validatePhoneNumber = (phoneNumber: string) => {
  const phoneNumberRegex = /^\d{11}$/;

  return phoneNumberRegex.test(phoneNumber);
};

export const validateSubmitBirth = (birthdate: string) => {
  // Check length
  if (birthdate.length !== 6) {
    return false;
  }

  // Extract year, month, and day
  const year = Number(birthdate.slice(0, 2));
  const month = Number(birthdate.slice(2, 4));
  const day = Number(birthdate.slice(4, 6));

  // Validate year
  if (year < 1 || year > 99) {
    return false;
  }

  // Validate month
  if (month < 1 || month > 12) {
    return false;
  }

  // Validate day - Assumes all months have at least up to '31' days.
  if (day < 1 || day > 31) {
    return false;
  }

  return true;
};
